export const DEFAULT_ICON = 'check';
export const ICON_MARKUP_REGEX = /\[\[.+\]\]/gi;
export const ICON_REMOVE_WRAPPER_REGEX = /(\[\[|\]\])/gi;
